export const TypedDataRevision = {
    ACTIVE: '1',
    LEGACY: '0',
};
//# sourceMappingURL=typedData.js.map